/**
 * 守护榜
 */

define(function(require, exports, module) {

    var Base = require('c-base');
    var http = require('../../base/http');
    var itemTpl = require('./item.tmpl');
    var itemEmptyTpl = require('./empty-item.tmpl');

    var SendUserList = Base.extend({
        defaults: {
            wrap: '#J-SendUserList',
            content: '[node-id=list]',
            loading: '[node-id=loading]',
            itemEmptyTpl: itemEmptyTpl,
            itemTpl: itemTpl,
            minSize: 3
        },

        initialize: function() {
            let self = this;
            self.Parent.apply(self, arguments);

            let nodeWrap = this.nodeWrap = $(this.get('wrap'));
            let nodeContent = this.nodeContent = nodeWrap.find(this.get('content'));

            this.nodeLoading = nodeWrap.find(this.get('loading'));
            this.nodeError = nodeWrap.find(this.get('error'));
            this.nodeEmpty = nodeWrap.find(this.get('empty'));

            let params = nodeContent.data('params');

            if (params) {
                this.params = eval("(" + params + ")");
                this.acid = this.params.eventId.split(':')[0];
            }

            this.minSize = nodeContent.data('minsize') || this.get('minSize');

            this._showLoading();

            return this;
        },

        render() {
            UpAct.loading.show();
            this.loadData();

            return this;
        },

        refresh() {
            UpAct.loading.show();
            this.loadData();
        },

        loadData() {
            let self = this;

            let promise = http.fetch({
                url: UpAct.CONFIG.getSendUserList(),
                data: this.params
            });

            promise.done((res) => {
                if (res.code == "SC_SUCCESS") {
                    self.emit('success', res.data.user);
                    self.renderUI(res.data.user);
                }
                UpAct.loading.hide();
                this._hideLoading();
            })
        },

        renderUI: function(data) {
            
            this.data = data;
            
            this.renderList(data.sendList);

            UpAct.img();
            UpAct.grade();
        },
        /**
         * 渲染列表内容
         * @param data 数据
         * @param append 是否插入到列表中
         */
        renderList(data) {
            let self = this;
            let pageCount = this.pageCount;
            let nodeList = $('<ul>');
            let itemTpl = this.get('itemTpl');
            let itemEmptyTpl = this.get('itemEmptyTpl')
            let dataNum = data.length;

            $.each(data, function(i, item) {
                item.index = (i + 1);

                let nodeItem = itemTpl({
                    data: item,
                    acid: self.acid
                });
                if (nodeItem) {
                    nodeList.append(nodeItem);
                }
            });

            if (dataNum < this.minSize) {
                for (let i = 0; i < this.minSize - dataNum; i++) {
                    let nodeItem = itemEmptyTpl({
                        data: {
                            index: i + dataNum + 1
                        }
                    });
                    if (nodeItem) {
                        nodeList.append(nodeItem);
                    }
                }
            }

            this.nodeContent.html(nodeList);
        },
        /**
         * 显示loading
         */
        _showLoading: function() {
            if (this.nodeLoading) {
                this.nodeLoading.removeClass('hidden');
            }
        },
        /**
         * 隐藏loading
         */
        _hideLoading: function() {
            if (this.nodeLoading) {
                this.nodeLoading.addClass('hidden');
            }
        }
    });

    UpAct.SendUserList = SendUserList;

    module.exports = SendUserList;
});



// WEBPACK FOOTER //
// ./js/component/send-userlist/index.js